export const mutateDateTimeWithoutSeconds = (value) => {

    if (!value) {
        return null;
    }

    return value.substring(0, 16)
}
